export const InvestorGridConfig = {
    grid: {
        gridId: 'investorReportDetailGrid',
        height: 500,
        checkbox: true,
        edit: false,
        delete: false,
        info: false,
        pageSize: 100,
        groupable: true,
        document: true,
    },
    columns: {
        Id: {
            class: 'id',
            dataName: 'Id',
            type: 'number',
            title: 'Id',
            width: 100,
            hidden: true,
            editable: false
        },
        ProgramId: {
            class: 'value',
            dataName: 'ProgramId',
            type: 'string',
            title: 'Program Id',
            width: 150,
            hidden: true,
            editable: false,
        },
        ProgramName: {
            class: 'value',
            dataName: 'ProgramName',
            type: 'string',
            title: 'Program Name',
            width: 230,
            hidden: false,
            editable: false,
        },
        UnitPool: {
            class: 'choice',
            dataName: 'UnitPool',
            type: 'string',
            title: 'Unit Pool',
            width: 185,
            hidden: true,
            editable: false,
        },
        UnitClass: {
            class: 'choice',
            dataName: 'UnitClass',
            type: 'string',
            title: 'Unit Class',
            width: 185,
            hidden: false,
            editable: false
        },
        UnitType: {
            class: 'choice',
            dataName: 'UnitType',
            type: 'string',
            title: 'Unit Type',
            width: 185,
            hidden: false,
            editable: false
        },
        VestingType: {
            class: 'value',
            dataName: 'VestingType',
            type: 'string',
            title: 'Vesting Type',
            width: 185,
            hidden: false,
            readOnly: false,
        },
        Issuance: {
            class: 'value',
            dataName: 'Issuance',
            type: 'number',
            title: 'Issuance',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", Issuance!=null?Issuance:0 )#</span>',
            width: 185,
            hidden: true,
        },
        Transfer: {
            class: 'value',
            dataName: 'Transfer',
            type: 'number',
            title: 'Transfer',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", Transfer!=null?Transfer:0 )#</span>',
            width: 185,
            hidden: true,
        },
        Forfeiture: {
            class: 'value',
            dataName: 'Forfeiture',
            type: 'number',
            title: 'Forfeiture',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", Forfeiture!=null?Forfeiture:0 )#</span>',
            width: 185,
            hidden: true,
        },
        
        // UnitPrice: {
        //     class: 'value',
        //     dataName: 'UnitPrice',
        //     type: 'currency',
        //     title: 'Unit Price',
        //     template: '#=kendo.format("{0:c}", UnitPrice!=null?UnitPrice:0 )#',
        //     width: 185,
        //     hidden: false,
        //     editable: false
        // },
        TotalUnits: {
            class: "value",
            dataName: 'TotalUnits',
            type: 'number',
            title: 'Total Units',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", TotalUnits!=null?TotalUnits:0 )#</span>',
            width: 185,
            hidden: false,
        },
        // AwardedUnits: {
        //     class: "value",
        //     dataName: 'AwardedUnits',
        //     type: 'number',
        //     title: 'Awarded Units',
        //     template: '#=kendo.format("{0:n2}", AwardedUnits!=null?AwardedUnits:0 )#',
        //     width: 215,
        //     hidden: false,
        //     editable: false
        // },
        VestPercentage: {
            class: 'value',
            dataName: 'VestPercentage',
            type: 'vestpercent',
            title: 'Vested %',
            template: '<span class="number-cell-ui">#=kendo.format("{0:p0}", VestPercentage!=null?VestPercentage:0)#</span>',
            width: 185,
            hidden: false,
            editable: false
        },
        VestedUnits: {
            class: "value",
            dataName: 'VestedUnits',
            type: 'number',
            title: 'Vested Units',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", VestedUnits!=null?VestedUnits :0 ) #</span>',
            width: 205,
            hidden: false,
            editable: false
        },
        NextVestingDate: {
			class: 'value',
			dataName: 'NextVestingDate',
			type: 'string',
			title: 'Next Vesting Date',
			width: 185,
			hidden: false
        },
        CumulativeDistribution: {
            class: "value",
            dataName: 'CumulativeDistribution',
            type: 'currency',
            title: 'Cumulative Distribution',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", CumulativeDistribution!=null?CumulativeDistribution :0 ) #</span>',
            width: 230,
            hidden: false
        },
        PotentialValue: {
            class: "value",
            dataName: 'PotentialValue',
            type: 'number',
            title: 'Potential Value',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", PotentialValue!=null?PotentialValue :0 ) #</span>',
            width: 185,
            hidden: false
        },
        LiquidationValue: {
            class: "value",
            dataName: 'LiquidationValue',
            type: 'number',
            title: 'Liquidation Value',
            template: '<span class="number-cell-ui">#=kendo.format("{0:n2}", LiquidationValue!=null?LiquidationValue :0 ) #</span>',
            width: 185,
            hidden: false
        },
        OwnershipExcludingTreasuryUnits: {
            class: 'value',
            dataName: 'OwnershipExcludingTreasuryUnits',
            type: 'percent',
            title: 'Ownership (Excluding Treasury Units)',
            template: '<span class="number-cell-ui">#=kendo.format("{0:p}", OwnershipExcludingTreasuryUnits!=null?OwnershipExcludingTreasuryUnits:0)#</span>',
            width: 185,
            hidden: false,
        },
        OwnershipIncludingTreasuryUnits: {
            class: 'value',
            dataName: 'OwnershipIncludingTreasuryUnits',
            type: 'percent',
            title: 'Ownership (Including Treasury Units)',
            template: '<span class="number-cell-ui">#=kendo.format("{0:p}", OwnershipIncludingTreasuryUnits!=null?OwnershipIncludingTreasuryUnits:0)#</span>',
            width: 185,
            hidden: false,
         },
       
        // UnitsToBeRetained: {
        //     class: "value",
        //     dataName: 'UnitsToBeRetained',
        //     type: 'number',
        //     title: 'Additional Units to be Retained',
        //     template: '#=kendo.format("{0:n2}", UnitsToBeRetained!=null?UnitsToBeRetained:0 )#',
        //     width: 310,
        //     hidden: false,
        //     validation: { min: 0 },
        // },
        // TotalUnitsToBeRetained: {
        //     class: "value",
        //     dataName: 'TotalUnitsToBeRetained',
        //     type: 'number',
        //     title: 'Total Units To Be Retained',
        //     width: 290,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='TotalUnitsToBeRetained'>#= kendo.format('{0:n2}',TotalUnitsToBeRetained!=null?TotalUnitsToBeRetained:0) #</span>" //#= VestedUnits + UnitsToBeRetained #
        // },
        // UnitsToBeForfeited: {
        //     class: "value",
        //     dataName: 'UnitsToBeForfeited',
        //     type: 'number',
        //     title: 'Units To Be Forfeited',
        //     width: 250,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='UnitsToBeForfeited'>#=kendo.format('{0:n2}', UnitsToBeForfeited!=null?UnitsToBeForfeited:0)#</span>" //#= AwardedUnits - TotalUnitsToBeRetained #
        // },
        // SumofAwardedUnits: {
        //     class: "value",
        //     dataName: 'SumofAwardedUnits',
        //     type: 'number',
        //     title: 'Sum of Awarded Units',
        //     width: 185,
        //     hidden: true,
        //     editable: false,
        // },
        // AmountPaidForProgram: {
        //     class: "value",
        //     dataName: 'AmountPaidForProgram',
        //     type: 'currency',
        //     title: 'Amount Paid For Program',
        //     template: '#=kendo.toString(AmountPaidForProgram, "c")#',
        //     width: 175,
        //     hidden: true,
        //     editable: false,
        // },
        // AmountPaid: {
        //     class: "value",
        //     dataName: 'AmountPaid',
        //     type: 'currency',
        //     title: 'Amount Paid for Units',
        //     template: "<span class='AmountPaid'>#=kendo.toString(AmountPaid, 'c')#</span>", //#= AwardedUnits - TotalUnitsToBeRetained #
        //     width: 220,
        //     hidden: false,
        //     editable: false,
        // },
        // AmountPayable: {
        //     class: "value",
        //     dataName: 'AmountPayable',
        //     type: 'currency',
        //     title: 'Amount Payable to Partner',
        //     width: 290,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='AmountPayable'>#= kendo.toString(UnitPrice * TotalUnitsToBeRetained, 'c') #</span>"
        // },
        // AmountReceivable: {
        //     class: "value",
        //     dataName: 'AmountReceivable',
        //     type: 'currency',
        //     title: 'Amount Receivable from Partner',
        //     width: 290,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='AmountReceivable'>#= kendo.toString(UnitPrice * (AwardedUnits - TotalUnitsToBeRetained), 'c') #</span>"
        // },
        // Buyout: {
        //     class: "value",
        //     dataName: 'Buyout',
        //     type: 'currency',
        //     title: 'Buyout',
        //     width: 190,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='Buyout'>#= kendo.toString(Buyout, 'c') #</span>" //#= AmountPaid - AmountPayable #
        // },
        // AmountOwedToPartnership: {
        //     class: "value",
        //     dataName: 'AmountOwedToPartnership',
        //     type: 'currency',
        //     title: 'Amount Owed To Partnership',
        //     width: 320,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='AmountOwedToPartnership'>#= kendo.toString(AmountOwedToPartnership, 'c') #</span>" //#= AmountPayable - AmountPaid #
        // },
        // ContributionRelief: {
        //     class: "value",
        //     dataName: 'ContributionRelief',
        //     type: 'currency',
        //     title: 'Contribution Relief',
        //     width: 250,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='ContributionRelief'>#= kendo.toString(ContributionRelief, 'c') #</span>" //AmountReceivable - Buyout
        // },
        // NetPayout: {
        //     class: "value",
        //     dataName: 'NetPayout',
        //     type: 'currency',
        //     title: 'Net Payout',
        //     width: 210,
        //     hidden: false,
        //     editable: false,
        //     template: "<span class='NetPayout'>#= kendo.toString(NetPayout, 'c') #</span>" //#= Buyout - AmountOwedToPartnership #
        // }

    }
}

export const InvestorDetailToolBarConfig = {
    // items: [
    //     {
    //         id: "btnBack",
    //         type: "button",
    //         text: "Back to Buyout Summary",
    //         showIcon: "toolbar",
    //         icon: "undo",
    //         attributes: { "class": "btn btn-secondary float-right-btn" }
    //     },
    // ]
    items: [
        {
            template: '<space><input type="radio" name="View" id="summaryView" checked/> Summary View  <space><input type="radio" name="View" id="detailView"/> Detail View',
            attributes: { "class": "radioButton  float-right-btn" } 
            //Class = 'radioButton' is required for using Radio Buttons in ToolBar
        },
    ]
}
